<template>
  <div>
    <div class="pre-footer"></div>
    <footer>
      <div class="container">
        <p class="text-center">Copyright (c) 2021</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
.pre-footer {
  background-color: #f0f0f0;
  height: 4rem;
}
</style>
